import React, {useMemo} from "react";

type TZeeroLoading = {
	type?: "primary" | "success" | "error" | "warn"
	className?: string,
	current?: number,
	total?: number,
	message?: string,
	appendEllipsis?: boolean
}

export default function ZeeroLoading({
										 type = "primary",
										 className,
										 current,
										 total,
										 message,
										 appendEllipsis = true
									 }: TZeeroLoading) {
	const percentage = useMemo(() => {
		return Math.round((current! / total!) * 100)
	}, [current, total]);

	return <div className={`zeero-loading ${className ? className : ""}`}>
		<div className="zeero-loading-progress-container">
			{current == undefined || total == undefined
					? <div className={`zeero-loading-progress-bar infinite ${type}`}></div>
					: <div className={`zeero-loading-progress-bar ${type}`} style={{width: `calc(${percentage}% - var(--bar-margin) * 2)`}}></div>}
		</div>
		{message && (
				<div className={`zeero-loading-progress-text ${appendEllipsis ? "ellipsis" : ""}`}>
					{message}
				</div>
		)}
	</div>
}